import * as React from "react"
import { Container } from "react-bootstrap"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import Table from "../../components/Table"

import useOtherTemplesData from "../../hooks/useOtherTemplesData.js"

const OtherTemplesPage = ({location}) => {
	const columns = [
		{ name: "English Name", key: "english_name_I" },
		{ name: "Chinese Name", key: "chinese_name_I" },
		{ name: "Address", key: "full_address" },
	]

	const data = useOtherTemplesData()

	return (
		<Layout location={location}>
			<Seo title="Index of Other Temples" />

			<Container>
				<h1>Other Temples</h1>

				<Table
					columns={columns}
					data={data}
					paginationSize={50}
					routeLink={() => "/map"}
					routeState={({ id }) => ({ id })}
				/>

			</Container>

		</Layout>
	)
}

export default OtherTemplesPage
